import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.deepPurple.accent2,
        primary_2: "#304FFE",
        secondary: colors.blue.accent3,
      },
      dark: {
        primary: colors.deepPurple.accent2,
        secondary: colors.blue.accent3,
      },
    },
  },
});
